import { isValidPhoneNumber, parsePhoneNumberFromString, } from 'libphonenumber-js/max';
export var phoneUtils = {
    getPureString: function (phone) {
        return (phone || '').replace(/[^\d]/g, '');
    },
    isValid: function (phone) {
        if (typeof phone === 'undefined') {
            return false;
        }
        return isValidPhoneNumber(phone, 'DE');
    },
    format: function (phone) {
        var cleanNumber = phoneUtils.getPureString(phone);
        var parsedNumber = parsePhoneNumberFromString(cleanNumber, 'DE');
        if (typeof parsedNumber === 'undefined') {
            return cleanNumber;
        }
        return parsedNumber.formatNational();
    },
};
